import { render } from "./DentiumErpGoalManagement.vue?vue&type=template&id=f9c40440&scoped=true"
import script from "./DentiumErpGoalManagement.vue?vue&type=script&lang=js"
export * from "./DentiumErpGoalManagement.vue?vue&type=script&lang=js"

import "./DentiumErpGoalManagement.vue?vue&type=style&index=0&id=f9c40440&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9c40440"]])

export default __exports__